import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { IconModule } from '../icon/icon.module';

export type BannerVariant = 'info' | 'warning' | 'success' | 'error';
export type BannerPosition = 'top' | 'bottom' | 'static';

@Component({
  selector: 'lib-banner',
  styleUrls: ['./banner.component.scss'],
  template: `
    <div class="banner__detailText">{{ detailText() }}</div>
    <div class="banner__header">
      <span class="banner__icon" aria-hidden="true">
        <ng-content select="[bannerIcon]"></ng-content>
      </span>
      @if (title()) {
        <strong class="banner__title">{{ title() }}</strong>
      }
      @if (showClose()) {
        <button
          class="banner__close"
          type="button"
          (click)="onClose()"
          aria-label="Stäng"
        >
          <lib-icon name="x" aria-hidden="true"></lib-icon>
        </button>
      }
    </div>
    <div class="banner__body">
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconModule],
  host: {
    '[class.banner]': 'true',
    '[class.banner--info]': "variant() === 'info'",
    '[class.banner--warning]': "variant() === 'warning'",
    '[class.banner--success]': "variant() === 'success'",
    '[class.banner--error]': "variant() === 'error'",
    '[class.banner--top]': "position() === 'top'",
    '[class.banner--bottom]': "position() === 'bottom'",
    '[class.banner--static]': "position() === 'static'",
    '[attr.role]': "variant() === 'error' ? 'alert' : 'status'",
    '[attr.aria-live]': "variant() === 'error' ? 'assertive' : 'polite'",
  },
})
export class BannerComponent {
  variant = input<BannerVariant>('info');
  position = input<BannerPosition>('static');
  title = input<string>();
  detailText = input<string>();
  showClose = input<boolean>(false);

  closed = output<void>();

  onClose(): void {
    this.closed.emit();
  }
}
